import React from "react";
import SearchResult from "../searchResult/searchResult";
import v4 from "uuid/v4";
import FaSpinner from "../../faSpinner/faSpinner";
import "./searchResultList.css";
import DropDownMenu from "../../dropDownMenu/dropDownMenu";
import SearchNew from "../searchNew";
import { useSearch } from "../searchProvider";

const CATEGORIES = [
  {
    name: "Article",
    value: "article",
  },
  {
    name: "Product",
    value: "api_product",
  },
  {
    name: "FAQ",
    value: "faq",
  },
];

const SearchResultList = () => {
  const { listItems, query, loading, onCategoryChange, onSearch } = useSearch();

  return (
    <div className="searchArea-wrapper" style={{ minHeight: 850 }}>
      <div className="searchArea">
        <div className="searchBar">
          <div className="sTitle">
            <span>
              {query === ""
                ? "Type something in the search bar..."
                : "Showing results for:"}
            </span>
          </div>
          <SearchNew onSearch={(e) => onSearch(e.target.value)} query={query} />
        </div>
        <div className="searchDropdown">
          <div className="sTitle">
            <span>Search in:</span>
          </div>
          <div className="side_field">
            <DropDownMenu
              name={"ALL"}
              items={CATEGORIES}
              selectHandler={(e) => onCategoryChange(e ? e.value : null)}
            />
          </div>
        </div>
        <div style={{ clear: "both" }}></div>
      </div>
      {listItems && listItems.length > 0 && query !== "" ? (
        <div className="search-results-container">
          {listItems.map((item) => {
            // Format the item for display
            const formattedItem = {
              ...item,
              title: item.title || "Untitled",
              created: item.created ? new Date(item.created) : null,
            };

            // Get type label
            let typeLabel = "";
            if (item.type === "api_endpoint") {
              typeLabel = "API";
            } else if (item.type === "api_product") {
              typeLabel = "Product";
            } else if (item.type === "article") {
              typeLabel = "Article";
            } else if (item.type === "faq") {
              typeLabel = "FAQ";
            }

            return (
              <div key={v4()} className="search-result-item">
                <div className="result-header">
                  <SearchResult
                    link={formattedItem.link}
                    title={formattedItem.title}
                    description={formattedItem.description}
                    query={query}
                    created={formattedItem.created}
                  />
                  <div className="result-meta">
                    {typeLabel && (
                      <span className={`type-badge type-${item.type}`}>
                        {typeLabel}
                      </span>
                    )}
                    {item.deprecated && (
                      <span className="deprecated-badge">Deprecated</span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : !loading && query !== "" ? (
        <div className="result">
          <div className="rInfo">
            <div className="rTitle">Your search yielded no results</div>
            <div className="rDescription">
              <p>
                Check if your spelling is correct and remove quotes around
                phrases to search for each word individually.
              </p>
            </div>
          </div>
        </div>
      ) : null}
      <div
        style={{
          clear: "both",
          marginTop: 22,
          display: "inline-block",
          width: "100%",
        }}
      >
        <FaSpinner loading={loading} />
      </div>
    </div>
  );
};

export default SearchResultList;
